import theme from '../../base';

const button = {
  default: {
    borderFocused: theme.colors.blues.blue300,
  },
  disabled: {
    bg: theme.colors.neutrals.gray250,
    border: theme.colors.neutrals.gray250,
    foreground: theme.colors.neutrals.gray500,
  },
  ghost: {
    bg: theme.colors.neutrals.transparent,
    bgActive: theme.colors.neutrals.gray200,
    bgHover: theme.colors.neutrals.gray200,
    border: theme.colors.neutrals.transparent,
    borderHover: theme.colors.neutrals.gray200,
    foreground: theme.colors.neutrals.gray800,
    foregroundHover: theme.colors.neutrals.gray700,
  },
  like: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.neutrals.gray800,
    iconHover: theme.colors.blues.blue500,
  },
  liked: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.blues.blue800,
    iconHover: theme.colors.neutrals.gray800,
  },
  dislike: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.neutrals.gray800,
    iconHover: theme.colors.reds.red500,
  },
  disliked: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.reds.red800,
    iconHover: theme.colors.neutrals.gray800,
  },
  store: {
    bg: theme.colors.secondary.secondary500,
    bgActive: theme.colors.secondary.secondary700,
    bgHover: theme.colors.secondary.secondary700,
    border: theme.colors.secondary.secondary500,
    borderHover: theme.colors.secondary.secondary700,
    foreground: theme.colors.neutrals.white,
  },
  primary: {
    bg: theme.colors.primary.primary500,
    bgActive: theme.colors.primary.primary700,
    bgHover: theme.colors.primary.primary700,
    border: theme.colors.primary.primary500,
    borderHover: theme.colors.primary.primary700,
    foreground: theme.colors.neutrals.white,
  },
  secondary: {
    bg: theme.colors.neutrals.white,
    bgActive: theme.colors.primary.primary500,
    bgHover: theme.colors.primary.primary100,
    border: theme.colors.primary.primary500,
    borderActive: theme.colors.primary.primary500,
    borderHover: theme.colors.primary.primary500,
    foreground: theme.colors.primary.primary500,
    foregroundActive: theme.colors.neutrals.white,
  },
  subtle: {
    bg: theme.colors.neutrals.gray200,
    bgHover: theme.colors.neutrals.gray250,
    border: theme.colors.neutrals.gray200,
    borderHover: theme.colors.neutrals.gray250,
    borderActive: theme.colors.neutrals.gray250,
    foreground: theme.colors.neutrals.gray800,
    foregroundHover: theme.colors.neutrals.gray800,
  },
};

export default button;
